/* eslint-disable  @typescript-eslint/no-explicit-any */
import { IGetInvoiceResponse } from '~/src/repositories/Invoice/models/Invoice'

export function convertInvoice(data: any): IGetInvoiceResponse {
  const invoices = data.items.map((item: any) => ({
    id: item?.id,
    invoiceNo: item?.invoice?.filename ?? 'Invoice No',
    invoiceType: item?.type ?? '',
    companyName: item?.user?.companyName ?? 'Company Name',
    customer: item?.user?.name ?? '',
    dateOfCreation: item?.dateOfCreation ?? '',
    status: item?.status ?? 'Status',
    proofOfPayment: item?.paymentProof?.url ?? 'なし',
  }))

  const pagination = data.pagination
  return {
    invoices,
    pagination,
  }
}
